import {ReactElement, useContext, useState} from "react";
import {ViziblyTheme} from "../analyst/ViziblyZDGTheme";
import AdminHeader from "../admin/AdminHeader";
import {ThemeProvider} from "@zendeskgarden/react-theming";
import {AdminWrapper} from "../admin/AdminWrapper";
import PropertyReforecastManagement from "./PropertyReforecastManagement";
import {Tab, TabList, TabPanel, Tabs} from "@zendeskgarden/react-tabs";
import {ManualPropertyList} from "../property/manual-property/ManualPropertyList";
import FeatureRestrictedOverlay from "../../components/feature-restricted-overlay/FeatureRestrictedOverlay";
import {PropertyTags} from "../property-tags/PropertyTags";
import {AuthContext} from "../../contexts/AuthContext";
import {getBudgetYearForProperty, useProperties} from "../../contexts/properties/PropertiesContext";

enum PropertyManagementTabs {
    PropertyReforecastManagement = "property-reforecast-management",
    PropertyList = "property-list",
    PropertyTags = "property-tags",
}

export function PropertyManagement(): ReactElement {
    const [selectedTab, setSelectedTab] = useState<string>(PropertyManagementTabs.PropertyList);
    const auth = useContext(AuthContext);
    const {currentProperty} = useProperties();
    const budgetYear = getBudgetYearForProperty(currentProperty, auth.budgetYear);

    return <ThemeProvider theme={ViziblyTheme}>
        <AdminWrapper>
            <FeatureRestrictedOverlay coverPage />

            <AdminHeader
                title={"Property Management"}
                subtitle={"Check Property names and update reforecast start month"}
            />
            <Tabs selectedItem={selectedTab} onChange={setSelectedTab}>
                <TabList>
                    <Tab item={PropertyManagementTabs.PropertyList}>Property List</Tab>
                    <Tab item={PropertyManagementTabs.PropertyReforecastManagement}>Reforecast Management</Tab>
                    <Tab item={PropertyManagementTabs.PropertyTags}>Property Tags</Tab>
                </TabList>
                <TabPanel item={PropertyManagementTabs.PropertyList}>
                    {selectedTab === PropertyManagementTabs.PropertyList ? <ManualPropertyList budgetYear={budgetYear} /> : <></>}
                </TabPanel>
                <TabPanel item={PropertyManagementTabs.PropertyReforecastManagement}>
                    {selectedTab === PropertyManagementTabs.PropertyReforecastManagement ? <PropertyReforecastManagement /> : <></>}
                </TabPanel>
                <TabPanel item={PropertyManagementTabs.PropertyTags}>
                    {selectedTab === PropertyManagementTabs.PropertyTags ? <PropertyTags /> : <></>}
                </TabPanel>
            </Tabs>
        </AdminWrapper>
    </ThemeProvider>;
}